export const showOnDesktopS = "s1e1tnw6";
export const hideOnDesktopS = "hs1bmwf";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");